import UIWrapper from "../../../components/UIWrapper";
import { Typography, Checkbox } from "@mui/material";
import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { snackbarActions } from "../../../Store/snackbar";
import { Box } from "../../../mui";
import {
    DataGrid,
  } from "@mui/x-data-grid";
import DataInterfaceService from "../../../services/DataInterfaceService";

const InterfaceManager = () => {
    const [tableData, setTableData] = useState([]);
    const [dataLoading, setDataLoading] = useState(false);
    const dispatch = useDispatch();
    const [checkboxLoading, setCheckboxLoading] = useState({});

    const commonDispatch = (type, message) => {
        dispatch(
          snackbarActions.showNotification({
            snackbarOpen: true,
            snackbarType: type,
            snackbarMessage: message,
          })
        );
      };

    const handleCheckboxChange = async (row, newValue) => {
        setCheckboxLoading((prev) => ({ ...prev, [row.id]: true }));
        try {
            const payload = {
                client: row.client,
                interface: row.interface,
                auto_processing_enabled: newValue,
            };
            await DataInterfaceService.postAutoProcessing(payload);
            commonDispatch("success", "Auto AF2 Processing status updated successfully!");
            setTableData((prev) =>
                prev.map((item) =>
                    item.id === row.id
                        ? { ...item, auto_processing_enabled: newValue }
                        : item
                )
            );
        } catch (err) {
            console.error(err);
            commonDispatch("error", err.message);
        } finally {
            setCheckboxLoading((prev) => ({ ...prev, [row.id]: false }));
        }
    };
    
    const InterfaceColumns = [
        {
        field: "client",
        headerName: "Client",
        minWidth: 300,
        editable: false,
        renderCell: (params) => {
            return (
            <Typography variant="p" color="secondary.main" title={params.value}>
                {params.value}
            </Typography>
            );
        },

        valueGetter: (params) => {
            return params ?? "None/Null";
        },
        },
        
        {
        field: "interface",
        headerName: "LIMS Interface",
        minWidth: 350,
        editable: false,
        renderCell: (params) => {
            return (
            <Typography variant="p" color="secondary.main" title={params.value}>
                {params.value}
            </Typography>
            );
        },

        valueGetter: (params) => {
            return params ?? "None/Null";
        },
        },

        {
            field: "auto_processing_enabled",
            headerName: "Auto AF2 Processing < 15K",
            minWidth: 300,
            editable: false,
            renderCell: (params) => {
                return (
                    <Checkbox
                        checked={params.value === true}
                        onChange={(event) =>
                            handleCheckboxChange(params.row, event.target.checked)
                        }
                        disabled={checkboxLoading[params.row.id]}
                        color="primary"
                    />
                );
            },
            valueGetter: (params) => {
                return params ?? "None/Null";
            },
        },
        
    ];

    useEffect(() => {
        getAF2ProcessingRecords();
        return;
    }, []);

    const getAF2ProcessingRecords = async () => {
        setDataLoading(true);
        await DataInterfaceService.getAF2DataProcessingRecords()
        .then((resp) => {
            setTableData(
                resp.data.map((row, id) => {
                return { id, ...row };
            })
            );
        })
        .catch((err) => {
            console.log(err);
            commonDispatch("error", err.message);
        });
        setDataLoading(false);
    };

  return (
    <UIWrapper title="Data Interface Manager" paper>
      <Box
        sx={{
          width: "100%",
          marginTop: "20px",
        }}
      >
        
        <Box
          height="375px"
          display="flex"
          justifyContent="center"
          alignItems="center"
          width="100%"
        >
          <DataGrid
            rows={tableData}
            columns={InterfaceColumns}
            loading={dataLoading}
            density="compact"
            disableSelectionOnClick
            sx={{
              "& .MuiDataGrid-columnHeaderTitle": {
                fontWeight: "bold",
              },
            }}
          />
        </Box>
      </Box>
    </UIWrapper>
  );
};

export default InterfaceManager;
